import React, { Component } from "react";
import PropTypes from "prop-types";
import GStepper from "./ui/GStepper";
import { inject, observer } from "mobx-react";
import {
  isDeal,
  isFlashDeal,
  maxPurchaseLimitReached
} from "../utils/ProductUtils";
import { withRouter } from "react-router";

@inject(["orderStore"])
@inject(["productStore"])
@inject(["customerStore"])
@observer
class AddToCartButtonPart extends Component {
  componentWillUnmount() {
    this.props.orderStore.cancel();
  }

  addOne = () => {
    const {
      props: { orderStore, productStore, product, listName, query, CTListName },
      getProduct
    } = this;

    productStore.setSelectedProduct(product);

    // no toast on add: the stepper's pop animation is the confirmation
    orderStore.addOne(getProduct(), listName, CTListName, query);
  };

  removeOne = () => {
    const {
      props: { orderStore, listName, CTListName },
      getProduct
    } = this;

    orderStore.removeOne(getProduct(), listName, CTListName);
  };

  getProduct = () => {
    const { product, orderStore } = this.props;
    const orderStoreProduct = orderStore.all.get(product.id);
    if (
      orderStoreProduct &&
      orderStoreProduct.id &&
      product.order_quantity !== orderStoreProduct.order_quantity
    ) {
      return { ...product, order_quantity: orderStoreProduct.order_quantity };
    }
    return { ...product };
  };

  componentDidMount() {
    const { orderStore } = this.props;
    const clonedProduct = this.getProduct();
    if (maxPurchaseLimitReached(clonedProduct)) {
      if (isFlashDeal(clonedProduct)) {
        clonedProduct.order_quantity =
          clonedProduct.flash_deal.allowed_quantity;
      } else if (isDeal(clonedProduct)) {
        clonedProduct.order_quantity = clonedProduct.max_purchase_limit;
      }
      orderStore.all.set(clonedProduct.id, clonedProduct);
    }
  }

  render() {
    const {
      props: { className, orderStore, product, small, variant },
      getProduct
    } = this;
    const size = variant || (small ? "inline" : "tile");

    return (
      <GStepper
        className={className}
        size={size}
        name={product.name}
        qty={
          orderStore.all.has(product.id) ? orderStore.getQuantity(product) : 0
        }
        onAdd={this.addOne}
        onRemove={this.removeOne}
        addDisabled={Boolean(maxPurchaseLimitReached(getProduct()))}
        limitLabel="Limited products"
      />
    );
  }
}

AddToCartButtonPart.propTypes = {
  product: PropTypes.object.isRequired,
  listName: PropTypes.string,
  CTListName: PropTypes.string,
  query: PropTypes.string,
  // tile: floating round "+" on a product image · inline: cart rows · lg: product page
  variant: PropTypes.oneOf(["tile", "inline", "lg"])
};

export default withRouter(AddToCartButtonPart);
